import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getStaffUsers = createAsyncThunk(
  "Staff/getStaffUsers",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${
          process.env.REACT_APP_BASE_URL
        }api/users/staff-management?pageNumber=${
          data?.pageNumber || 1
        }&pageSize=25&sortBy=full_name&sortOrder=asc`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
